import React, { useEffect, useId, useRef, useState } from "react"
import { withOrientationChange } from "react-device-detect"
import carret from "@/public/icons/arrow-up.svg"
import { getAnalyticsData } from "@/components/ProductList/v2/Sort/sortAnalytics"
import useOnClickOutside from "@/hooks/useOnClickOutside"

function Sort({
  texts = {},
  data = [],
  selectedSort,
  onChange,
  page,
  selectedtab,
  tabIndex = 0,
  isMyFavoriteTab = false,
}) {
  const id = useId()
  const [isOpen, setIsOpen] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const wrapper = useRef(null)
  const trigger = useRef(null)
  const options = useRef([])
  const label = texts.sort || texts.sortByAria || "Sort by"

  useOnClickOutside(wrapper, () => setIsOpen(false))
  useEffect(() => {
    if (isOpen) options.current[activeIndex]?.focus()
  }, [isOpen, activeIndex])

  const open = () => {
    if (!data.length) return
    setActiveIndex(
      Math.max(
        0,
        data.findIndex(item => item.name === selectedSort?.name)
      )
    )
    setIsOpen(true)
  }
  const close = () => {
    setIsOpen(false)
    trigger.current?.focus()
  }
  const select = item => {
    onChange(item)
    close()
  }
  const onOptionKeyDown = (event, index) => {
    switch (event.key) {
      case "ArrowDown":
        event.preventDefault()
        setActiveIndex((index + 1) % data.length)
        break
      case "ArrowUp":
        event.preventDefault()
        setActiveIndex((index - 1 + data.length) % data.length)
        break
      case "Home":
      case "End":
        event.preventDefault()
        setActiveIndex(event.key === "Home" ? 0 : data.length - 1)
        break
      case "Enter":
      case " ":
        event.preventDefault()
        select(data[index])
        break
      case "Escape":
        event.preventDefault()
        event.stopPropagation()
        close()
        break
      case "Tab":
        // Return to the trigger before the browser performs normal Tab navigation.
        close()
        break
      default:
        break
    }
  }

  return (
    <div
      className={`sort${isOpen ? " sort--open" : ""}`}
      ref={wrapper}
      onBlur={event => {
        if (!event.currentTarget.contains(event.relatedTarget)) setIsOpen(false)
      }}
    >
      <button
        type="button"
        tabIndex={tabIndex}
        className="sort__toggle"
        ref={trigger}
        id={`${id}-label`}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-controls={`${id}-options`}
        onClick={() => (isOpen ? close() : open())}
        onKeyDown={event => {
          if (["ArrowDown", "ArrowUp"].includes(event.key)) {
            event.preventDefault()
            open()
          } else if (event.key === "Escape" && isOpen) {
            event.preventDefault()
            close()
          }
        }}
      >
        <div className="sort-by-text">{label}</div>
        <div className="sort-options">{` ${isMyFavoriteTab ? "" : ":"} ${
          selectedSort?.name || "Featured"
        }`}</div>
        <img src={carret?.src} alt="" className="sort__toggle-icon" />
      </button>
      <ul
        id={`${id}-options`}
        className="sort__drop-down"
        role="listbox"
        aria-labelledby={`${id}-label`}
        hidden={!isOpen}
        style={!isOpen ? { display: "none" } : undefined}
      >
        {data.map((item, index) => (
          <li
            key={index}
            id={`${id}-option-${index}`}
            role="option"
            ref={element => {
              options.current[index] = element
            }}
            tabIndex={isOpen && activeIndex === index ? 0 : -1}
            aria-selected={item.name === selectedSort?.name}
            className={`sort__item gbh-data-layer${
              item.name === selectedSort?.name ? " active" : ""
            }`}
            data-gbh-data-layer={getAnalyticsData(item, null, {
              selectedtab,
              page,
            })}
            onFocus={() => setActiveIndex(index)}
            onClick={() => select(item)}
            onKeyDown={event => onOptionKeyDown(event, index)}
          >
            {item.name}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default withOrientationChange(Sort)
